import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    keyed: 0,

    active: null,
    id: null,

    frame: null,
    paused: null,

    // 
    keyframe: null
  },

  mutations: {
    keyLeveled(state, level) {
      state.keyed = level
    },

    frameOpened(state, frame) {
      state.frame = frame;
    },

    frameClosed(state) {
      state.frame = null;
    },

    sectioned(state, idx) {
      state.frame.section = idx
    },

    positioned(state, idx) {
      state.frame.position = idx
    },

    SOCKET_STATE(state, { active, id }) {
      state.active = active
      state.id = id
    },

    SOCKET_PAUSED(state, paused) {
      state.paused = paused
    },

    SOCKET_KEYFRAME(state, keyframe) {
      if (keyframe) {
        const { type, id, timestamp, section, position } = keyframe
      
        state.keyframe = {
          type,
          id,
          timestamp,
          section: +section,
          position: +position
        }
      } else {
        state.keyframe = keyframe;
      }
    }
  },

  actions: {
    useKeyLevel({ commit }, level) {
      commit('keyLeveled', level);
    },

    logOut() {
      this._vm.$socket.client.emit('stop');

      sessionStorage.removeItem('token'); // @TODO
    },

    frameOpened({ state, commit }, frame) {
      if (!frame.section) {
        frame.section = 0
      }
      
      if (!frame.position) {
        frame.position = 0
      }

      commit('frameOpened', frame);

      if (state.id === this._vm.$socket.client.id) {
        this._vm.$socket.client.emit('frame', frame);
      }
    },

    frameClosed({ state, commit }) {
      commit('frameClosed');

      if (state.id === this._vm.$socket.client.id) {
        this._vm.$socket.client.emit('frame', null);
      }
    },

    sectioned({ commit }, section) {
      commit('sectioned', section);
      this._vm.$socket.client.emit('section', section);
    },

    positioned({ commit }, position) {
      commit('positioned', position);
      this._vm.$socket.client.emit('position', position);
    },

    updated(_, timestamp) {
      this._vm.$socket.client.emit('updated', timestamp);
    },

    publish({ state }) {
      this._vm.$socket.client.emit('publish');
      
      if (state.frame) {
        this._vm.$socket.client.emit('frame', state.frame);
      }
    },

    pause() {
      this._vm.$socket.client.emit('pause');
    },

    play() {
      this._vm.$socket.client.emit('play');
    },
    
    stop() {
      this._vm.$socket.client.emit('stop');
    },

    toggle({ state }) {
      if (state.paused) {
        this._vm.$socket.client.emit('play');
      } else {
        this._vm.$socket.client.emit('pause');
      }
    }
  }
})

export default store